import { PencilSquareIcon } from '@shared/assets/icons';
import { EditParticipantTextModal } from '@features/clients';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import clsx from 'clsx';
import { useState } from 'react';
import styles from './ReviewCell.module.scss';

interface ReviewCellProps {
  review: string | null;
  onChange: (review: string) => void;
  participantName: string;
  modalTitle: string;
  emptyText?: string;
  placeholder?: string;
  fieldLabel?: string;
}

export const ReviewCell = ({
  review,
  onChange,
  participantName,
  modalTitle,
  emptyText = 'Нет отзыва',
  placeholder = 'Введите отзыв',
  fieldLabel,
}: ReviewCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasReview = Boolean(review);
  const displayText = review || emptyText;
  const modalValue = review || '';
  const reviewClassName = clsx(styles.review, !hasReview && styles.reviewEmpty);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <div className={styles.container}>
        <UnstyledButton className={styles.editButton} onClick={handleOpenModal}>
          <span className={styles.editButtonContent}>
            <PencilSquareIcon size="16" color="currentColor" />
            Редактировать
          </span>
        </UnstyledButton>

        <div className={reviewClassName}>{displayText}</div>
      </div>

      <EditParticipantTextModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={onChange}
        title={modalTitle}
        participantName={participantName}
        value={modalValue}
        placeholder={placeholder}
        fieldLabel={fieldLabel}
      />
    </>
  );
};
